import axios from "axios";
const api_key =
  "28b4b56939b14fdf30bcefeb3e935193b0f07ce22523ab5d32afcf3f4151edc0";
const AXIOS = axios.create({
  baseURL:
    process.env.BASEURL ||
    // "https://a99e-182-185-195-64.ngrok-free.app"
    //  ||
    "https://server.vzsolution.com",
});

export { AXIOS, api_key };
